import {
  Grid,
  Card,
  Typography,
  TextField,
  Autocomplete,
  Switch,
  FormGroup,
  FormControlLabel,
  RadioGroup,
  FormControl,
  FormLabel,
  Radio,
  Stack,
} from "@mui/material";
import { useState, useEffect, useContext, useRef } from "react";
import { VehicleCard } from "../../../components/vehicleCard";
import { FarmCard } from "../../../components/farmCard";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { AppLayout } from "../../../layouts/app";
import { TrackerRelationshipsService } from "../../../services/trackerRelationships";
import styles from "./AdminLanding.module.scss";
import { styled } from "@mui/material";

export const AdminLanding = () => {
  const [inOriginVehicles, setInOriginVehicles] = useState([]);
  const [inRouteVehicles, setInRouteVehicles] = useState([]);
  const [finishedRouteVehicles, setFinishedRouteVehicles] = useState([]);
  const [nonMonitoredVehicles, setNonMonitoredVehicles] = useState([]);
  const [cardFarmsOne, setCardFarmsOne] = useState([]);
  const [cardFarmsTwo, setCardFarmsTwo] = useState([]);
  const [cardFarmsThree, setCardFarmsThree] = useState([]);
  const [cardFarmsFour, setCardFarmsFour] = useState([]);
  const [updater, setUpdater] = useState();
  const [platesToSearch, setPlatesToSearch] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
  const trackerRelationshipsService = new TrackerRelationshipsService();
  const [selectedPlate, setSelectedPlate] = useState("");
  const [firstTimeLoading, setFirstTimeLoading] = useState(true);
  const [inputValueSwitch, setInputValueSwitch] = useState("vehicles");
  const [inputValueLabel, setInputValueLabel] = useState("Veículos");
  const updaterRef = useRef(null);
  const [idIntervalUpdateKanban, setIdIntervalUpdateKanban] = useState();
  const [typeOperationSelected, setTypeOperationSelected] = useState("ALL");
  const TIME_UPDATE_INFO_CARDS = 60000;
  /**
   * Start Updater
   */
  const startUpdater = (typeOperationSelected) => {
    const intervalUpdatekanban = setInterval(() => {
      getKanbanInformation(selectedPlate, typeOperationSelected);
    }, TIME_UPDATE_INFO_CARDS);
    setIdIntervalUpdateKanban(intervalUpdatekanban);
    sessionStorage.setItem("updateKanban", intervalUpdatekanban);
  };

  const stopUpdater = () => {
    clearInterval(updaterRef.current);
    updaterRef.current = null;
  };

  const handleResponseData = (cards, plate) => {
    let newNonMonitoredVehicles = [];
    let newInOriginVehicles = [];
    let newInRouteVehicles = [];
    let newFinishedRouteVehicles = [];
    let newCardOneFarms = [];
    let newCardTwoFarms = [];
    let newCardThreeFarms = [];
    let newCardFourFarms = [];
    let plates = [];

    cards.map((card) => {
      if (
        card.status === "NOT_MONITORED" &&
        (card.typeOperation === "OVOS" || card.typeOperation === "PINTOS" || card.typeOperation === "EMBRIÕES")
      ) {
        newNonMonitoredVehicles.push(card);
      } else if (
        card.status === "START_ROUTE" &&
        (card.typeOperation === "OVOS" || card.typeOperation === "PINTOS" || card.typeOperation === "EMBRIÕES")
      ) {
        newInOriginVehicles.push(card);
      } else if (
        card.status === "IN_PATH" &&
        (card.typeOperation === "OVOS" || card.typeOperation === "PINTOS" || card.typeOperation === "EMBRIÕES")
      ) {
        newInRouteVehicles.push(card);
      } else if (
        card.status === "END_ROUTE" &&
        (card.typeOperation === "OVOS" || card.typeOperation === "PINTOS" || card.typeOperation === "EMBRIÕES")
      ) {
        newFinishedRouteVehicles.push(card);
      } else if (card.typeOperation === "SALA1") {
        newCardOneFarms.push(card);
      } else if (card.typeOperation === "SALA2") {
        newCardTwoFarms.push(card);
      } else if (card.typeOperation === "SALA3") {
        newCardThreeFarms.push(card);
      } else if (card.typeOperation === "SALA4") {
        newCardFourFarms.push(card);
      }
      plates.push(card.vehiclePlate);
    });

    if (firstTimeLoading) {
      setTimeout(() => {
        setFirstTimeLoading(false);
      }, 100);
    }

    setNonMonitoredVehicles(newNonMonitoredVehicles);
    setInOriginVehicles(newInOriginVehicles);
    setInRouteVehicles(newInRouteVehicles);
    setFinishedRouteVehicles(newFinishedRouteVehicles);
    setCardFarmsOne(newCardOneFarms);
    setCardFarmsTwo(newCardTwoFarms);
    setCardFarmsThree(newCardThreeFarms);
    setCardFarmsFour(newCardFourFarms);
    setPlatesToSearch(plates);
  };

  const getKanbanInformation = (plate, typeOperationSelected) => {
    trackerRelationshipsService
      .getKanbanView(typeOperationSelected)
      .then((response) => {
        handleResponseData(response.data, plate);
      })
      .catch((error) => {
        const errResData = error.response.data;
        stopUpdater();
        if (errResData && errResData.includes("Driver with RFID Tag Value")) {
          /*let RFID = errResData.slice(28, 42);
                NotificationManager.error(`Motorista com RFID ${RFID} não cadastrado.`);*/
        }
      });
  };

  const handleChange = (event) => {
    setTypeOperationSelected(event.target.value);
    sessionStorage.setItem("valueTypeOperationKanban", event.target.value);
  };

  useEffect(() => {
    const breadcrumbs = [];

    setBreadcrumbs(breadcrumbs);
    var result = sessionStorage.getItem("valueKanban");
    if (result !== null) {
      setInputValueLabel(sessionStorage.getItem("valueKanbanLabel"));
      setInputValueSwitch(result);
    }

    let interval;
    var resultSelected = sessionStorage.getItem("valueTypeOperationKanban");
    if (resultSelected !== null) {
      setTypeOperationSelected(resultSelected);
      getKanbanInformation(selectedPlate, resultSelected);
      var intervalUpated = sessionStorage.getItem("updateKanban");
      clearInterval(intervalUpated);
      interval = setInterval(() => {
        getKanbanInformation(selectedPlate, resultSelected);
      }, TIME_UPDATE_INFO_CARDS);

      sessionStorage.setItem("updateKanban", interval);
    } else {
      getKanbanInformation(selectedPlate, typeOperationSelected);
      interval = setInterval(() => {
        getKanbanInformation(selectedPlate, typeOperationSelected);
      }, TIME_UPDATE_INFO_CARDS);

      sessionStorage.setItem("updateKanban", interval);
    }
    return () => {
      clearInterval(interval);
      stopUpdater();
    };
  }, [selectedPlate, typeOperationSelected]);

  const cardOneFarm =
    cardFarmsOne.length > 0 ? (
      cardFarmsOne.map((card, index) => {
        return (
          <Grid key={`cardOneFarm-${index}`} item xs={12}>
            <FarmCard card={card} />
          </Grid>
        );
      })
    ) : (
      <></>
    );

  const cardTwoFarm =
    cardFarmsTwo.length > 0 ? (
      cardFarmsTwo.map((card, index) => {
        return (
          <Grid key={`cardTwoFarm-${index}`} item xs={12}>
            <FarmCard card={card} />
          </Grid>
        );
      })
    ) : (
      <></>
    );

  const cardThreeFarm =
    cardFarmsThree.length > 0 ? (
      cardFarmsThree.map((card, index) => {
        return (
          <Grid key={`cardThreeFarm-${index}`} item xs={12}>
            <FarmCard card={card} />
          </Grid>
        );
      })
    ) : (
      <></>
    );

  const cardFourFarm =
    cardFarmsFour.length > 0 ? (
      cardFarmsFour.map((card, index) => {
        return (
          <Grid key={`cardFourFarm-${index}`} item xs={12}>
            <FarmCard card={card} />
          </Grid>
        );
      })
    ) : (
      <></>
    );

  const cardsInOrigin =
    inOriginVehicles.length > 0 ? (
      inOriginVehicles.map((vehicle, index) => {
        if (
          selectedPlate === "" ||
          vehicle.vehiclePlate.indexOf(selectedPlate) > -1
        ) {
          return (
            <Grid key={`cardsInOrigin-${index}`} item xs={12}>
              <VehicleCard
                nonMonitored={true}
                cardType="inOrigin"
                vehicle={vehicle}
                updater={updater}
                startUpdaterFnc={startUpdater}
                stopUpdateKanban={true}
              />
            </Grid>
          );
        }
      })
    ) : (
      <></>
    );

  const cardsInRoute =
    inRouteVehicles.length > 0 ? (
      inRouteVehicles.map((vehicle, index) => {
        if (
          selectedPlate === "" ||
          vehicle.vehiclePlate.indexOf(selectedPlate) > -1
        ) {
          return (
            <Grid key={`cardsInRoute-${index}`} item xs={12}>
              <VehicleCard
                cardType="inRoute"
                vehicle={vehicle}
                updater={updater}
                startUpdaterFnc={startUpdater}
                stopUpdateKanban={true}
              />
            </Grid>
          );
        }
      })
    ) : (
      <></>
    );

  const cardsFinished =
    finishedRouteVehicles.length > 0 ? (
      finishedRouteVehicles.map((vehicle, index) => {
        if (
          selectedPlate === "" ||
          vehicle.vehiclePlate.indexOf(selectedPlate) > -1
        ) {
          return (
            <Grid key={`cardsFinished-${index}`} item xs={12}>
              <VehicleCard
                cardType="finished"
                vehicle={vehicle}
                updater={updater}
                startUpdaterFnc={startUpdater}
                stopUpdateKanban={true}
              />
            </Grid>
          );
        }
      })
    ) : (
      <></>
    );

  const cardsNonMonitared =
    nonMonitoredVehicles.length > 0 ? (
      nonMonitoredVehicles.map((vehicle, index) => {
        if (
          selectedPlate === "" ||
          vehicle.vehiclePlate.indexOf(selectedPlate) > -1
        ) {
          return (
            <Grid key={`cardsNonMonitared-${index}`} item xs={12}>
              <VehicleCard
                nonMonitorated={true}
                cardType="nonMonitored"
                vehicle={vehicle}
                updater={updater}
                startUpdaterFnc={startUpdater}
                stopUpdateKanban={true}
              />
            </Grid>
          );
        }
      })
    ) : (
      <></>
    );

  const handlePlateSearch = (evt, value, reason, details) => {
    if (value === undefined || value === null) setSelectedPlate("");
    else setSelectedPlate(value);
  };

  const handleChangeSwitch = (evt, value) => {
    if (value === false) {
      setInputValueSwitch("farms");
      setInputValueLabel("Granjas");
      sessionStorage.setItem("valueKanbanLabel", "Granjas");
      sessionStorage.setItem("valueKanban", "farms");
      sessionStorage.setItem("valueTypeOperationKanban", "GRANJAS");
      setTypeOperationSelected("GRANJAS");
    } else if (value === true) {
      setInputValueSwitch("vehicles");
      setInputValueLabel("Veículos");
      sessionStorage.setItem("valueKanbanLabel", "Veículos");
      sessionStorage.setItem("valueKanban", "vehicles");
      setTypeOperationSelected("ALL");
      sessionStorage.setItem("valueTypeOperationKanban", "ALL");
    }
  };

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&::before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  return (
    <>
      {inputValueSwitch === "vehicles" ? (
        <AppLayout collapsed={true} id={"teste"}>
          <Grid container alignItems={'center'}>
            <Grid item xl={3} md={6} sm={8} xs={6}>
              <Autocomplete
                id="combo-plates"
                options={platesToSearch}
                sx={{ width: "100%", marginBottom: "0px" }}
                onChange={handlePlateSearch}
                size="small"
                renderInput={(params) => (
                  <TextField {...params} label="Pesquisar Veículos" />
                )}
              />
            </Grid>
            <Grid item xl={2} md={3} sm={4} xs={6}>
              <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={
                    <Stack direction="row" sx={{ alignItems: 'center' }}>
                      <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Granjas</Typography>
                      <Switch
                        sx={{
                          height: "45px",
                          width: "70px",
                          "& .MuiSwitch-switchBase": {
                            margin: 0,
                            padding: 1,
                            transform: "translateX(2px)",
                            "&.Mui-checked": {
                              color: "#fff",
                              transform: "translateX(30px)",
                              "& .MuiSwitch-thumb:before": {},
                              "& + .MuiSwitch-track": {
                                opacity: 1,
                                backgroundColor: "#5c7fb8",
                              },
                            },
                          },
                          "& .MuiSwitch-thumb": {
                            backgroundColor: "#21519f",
                            width: 28,
                            height: 28,
                            "&:before": {
                              content: "''",
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              left: 1,
                              top: 0,
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center",
                            },
                          },
                          "& .MuiSwitch-track": {
                            opacity: 1,
                            backgroundColor: "#5c7fb8",
                            borderRadius: 20 / 2,
                          },
                        }}
                        checked={true}
                        onChange={handleChangeSwitch}
                      />
                      <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Veículos</Typography>
                    </Stack>
                  }
                />
              </FormGroup>
            </Grid>
            <Grid item xl={7}>
              <FormControl>
                <FormLabel
                  id="demo-controlled-radio-buttons-group"
                  focused={false}
                >
                  Tipo de Operação
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  defaultValue={
                    sessionStorage.getItem("valueTypeOperationKanban") === null
                      ? "ALL"
                      : sessionStorage.getItem("valueTypeOperationKanban")
                  }
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="ALL"
                    control={
                      <Radio
                        icon={<BpIcon />}
                        checkedIcon={<BpCheckedIcon />}
                      />
                    }
                    label="Todas"
                  />
                  <FormControlLabel
                    value="OVOS"
                    control={
                      <Radio
                        icon={<BpIcon />}
                        checkedIcon={<BpCheckedIcon />}
                      />
                    }
                    label="Ovos"
                  />
                  <FormControlLabel
                    value="PINTOS"
                    control={
                      <Radio
                        icon={<BpIcon />}
                        checkedIcon={<BpCheckedIcon />}
                      />
                    }
                    label="Pintos"
                  />
                  <FormControlLabel
                    value="EMBRIOES"
                    control={
                      <Radio
                        icon={<BpIcon />}
                        checkedIcon={<BpCheckedIcon />}
                      />
                    }
                    label="Embriões"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item container xs={12} spacing={2}>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2} className={styles.kanbanColumn}>
                  <Grid item xs={12}>
                    <Card className={styles.inOriginCardHeader} elevation={3}>
                      <Typography
                        className={styles.inOriginCardText}
                        variant="h6"
                      >
                        Na Origem
                      </Typography>
                      <Typography
                        className={styles.inOriginCardText}
                        variant="h6"
                      >
                        {inOriginVehicles.length}
                      </Typography>
                    </Card>
                    {cardsInOrigin}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Card className={styles.inRouteCardHeader} elevation={3}>
                      <Typography
                        className={styles.inRouteCardText}
                        variant="h6"
                      >
                        A Caminho
                      </Typography>
                      <Typography
                        className={styles.inRouteCardText}
                        variant="h6"
                      >
                        {inRouteVehicles.length}
                      </Typography>
                    </Card>
                    {cardsInRoute}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Card className={styles.routeFinishedCardHeader} elevation={3}>
                      <Typography
                        className={styles.routeFinishedCardText}
                        variant="h6"
                      >
                        No Destino
                      </Typography>
                      <Typography
                        className={styles.routeFinishedCardText}
                        variant="h6"
                      >
                        {finishedRouteVehicles.length}
                      </Typography>
                    </Card>
                    {cardsFinished}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Card className={styles.nonMonitoredCardHeader} elevation={3}>
                      <Typography
                        className={styles.nonMonitoredCardText}
                        variant="h6"
                      >
                        Não Monitorados
                      </Typography>
                      <Typography
                        className={styles.nonMonitoredCardText}
                        variant="h6"
                      >
                        {nonMonitoredVehicles.length}
                      </Typography>
                    </Card>
                    {cardsNonMonitared}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AppLayout>
      ) : (
        <AppLayout collapsed={true} id={"teste"}>
          <Grid container alignItems={'center'}>
            <Grid item xl={3} md={6} sm={8} xs={6}>
              <Autocomplete
                id="combo-plates"
                options={platesToSearch}
                sx={{ width: "100%", marginBottom: "12px" }}
                onChange={handlePlateSearch}
                size="small"
                renderInput={(params) => (
                  <TextField {...params} label="Pesquisar Granjas" />
                )}
              />
            </Grid>
            <Grid item xl={2} md={3} sm={4} xs={6}>
              <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={
                    <Stack direction="row" sx={{ alignItems: 'center' }}>
                      <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Granjas</Typography>
                      <Switch
                        sx={{
                          height: "45px",
                          width: "70px",
                          "& .MuiSwitch-switchBase": {
                            margin: 0,
                            padding: 1,
                            transform: "translateX(2px)",
                            "&.Mui-checked": {
                              color: "#fff",
                              transform: "translateX(30px)",
                              "& .MuiSwitch-thumb:before": {},
                              "& + .MuiSwitch-track": {
                                opacity: 1,
                                backgroundColor: "#5c7fb8",
                              },
                            },
                          },
                          "& .MuiSwitch-thumb": {
                            backgroundColor: "#21519f",
                            width: 28,
                            height: 28,
                            "&:before": {
                              content: "''",
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              left: 1,
                              top: 0,
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center",
                            },
                          },
                          "& .MuiSwitch-track": {
                            opacity: 1,
                            backgroundColor: "#5c7fb8",
                            borderRadius: 20 / 2,
                          },
                        }}
                        onChange={handleChangeSwitch}
                      />
                      <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Veículos</Typography>
                    </Stack>
                  }
                />
              </FormGroup>
            </Grid>
            <Grid item container xs={12} spacing={2}>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2} className={styles.kanbanColumn}>
                  <Grid item xs={12}>
                    <Card className={styles.inOriginCardHeader} elevation={3}></Card>
                    {cardOneFarm}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Card className={styles.inOriginCardHeader} elevation={3}></Card>
                    {cardTwoFarm}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Card className={styles.inOriginCardHeader} elevation={3}></Card>
                    {cardThreeFarm}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={3} md={3} sm={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Card className={styles.inOriginCardHeader} elevation={3}></Card>
                    {cardFourFarm}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AppLayout>
      )}
    </>
  );
};
